import React from 'react'
import { connect } from 'react-redux'

const SwitchLocaleMobileMenu = ({ country, onClick }) => (
  <div className='Switch_locale_mobile_menu'>
    {country && (
      <label
        onClick={onClick}
        className='Switch_locale_mobile_menu__label Menu__link Link Head Link_single Link_light'
      >
        {country.title}
      </label>
    )}
  </div>
)

export default connect(state => {
  const currentCountry = window.localStorage.getItem('countryId') || null
  return {
    country: currentCountry && state.countries[currentCountry]
  }
})(SwitchLocaleMobileMenu)



// WEBPACK FOOTER //
// ./src/components/Locale/SwitchLocaleMobileMenu.jsx